module.exports = __webpack_public_path__ + "img/location-white.76a440f7.svg";